import { crossBackLace, mixBackLace, straightBackLace } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/lace/backLace'
import { Position } from 'src/types'
import {
  crossBackLace as crossBackLaceOfFront,
  straightBackLace as straightBackLaceOfFront
} from 'src/features/brands/atoms/canvas/rightThrow/glove/front/lace/backLace'
import { outfielderDefaultBackLace } from 'src/features/brands/atoms/canvas/rightThrow/glove/back/lace/outfielderDefaultBackLace'
import { outfielderDefaultBackLaceForFront } from 'src/features/brands/atoms/canvas/rightThrow/glove/front/lace/outfielderDefaultBackLace'

export const backLaceDrawerOfFront = (ctx: CanvasRenderingContext2D, backLaceValue: string, laceColor: string, position: Position): void => {
  switch (backLaceValue) {
    case 'straight':
      straightBackLaceOfFront(ctx, laceColor, 0, 0, 1)
      straightBackLaceOfFront(ctx, laceColor, 128, -270, 30)
      straightBackLaceOfFront(ctx, laceColor, 222, -260, 30)
      return
    case 'crossAndStraight':
      crossBackLaceOfFront(ctx, laceColor, 5, 0, 1)
      straightBackLaceOfFront(ctx, laceColor, 128, -270, 30)
      straightBackLaceOfFront(ctx, laceColor, 222, -260, 30)
      return
    case 'cross':
      crossBackLaceOfFront(ctx, laceColor, 5, 0, 1)
      crossBackLaceOfFront(ctx, laceColor, 128, -270, 30)
      crossBackLaceOfFront(ctx, laceColor, 225, -265, 30)
      return
    default:
      switch (position) {
        case 'outfielder':
          crossBackLaceOfFront(ctx, laceColor, 5, -15, 1)
          outfielderDefaultBackLaceForFront(ctx, laceColor, 0, 20, 0)
          return
        default:
          return
      }
  }
}

export const backLaceDrawer = (ctx: CanvasRenderingContext2D, backLaceValue: string, laceColor: string, position: Position): void => {
  switch (backLaceValue) {
    case 'straight':
      straightBackLace(ctx, laceColor)
      return
    case 'crossAndStraight':
      mixBackLace(ctx, laceColor)
      return
    case 'cross':
      crossBackLace(ctx, laceColor)
      return
    default:
      switch (position) {
        case 'outfielder':
          outfielderDefaultBackLace(ctx, laceColor)
          return
        default:
          return
      }
  }
}
